/**
 * Index des composants de contenu des pièces jointes
 * Permet de charger dynamiquement le contenu d'une pièce jointe par sa clé
 */

import type { ComponentType } from "react";
import type {
  PieceJointeContentProps,
  PieceJointeComponent,
} from "../../lib/types";

// Import de tous les composants de pièces jointes
import CatalogueDennosFormationRSE from "./catalogue-dennos-formation-rse";
import DevisConstructionAtelierProductionPJ from "./devis-construction-atelier-production-pj";
import FactureLeccoConstructionPJ from "./facture-lecco-construction-pj";
import FormationRSE from "./formation-rse";
import LicenceProCnam from "./licence-pro-cnam";
import OffreAbonnementEchosPJ from "./offre-abonnement-echos-pj";
import ProjetFormationDennosPJ from "./projet-formation-dennos-pj";
import ProjetHorairesVariables from "./projet-horaires-variables";
import ProjetInformatiquePJ from "./projet-informatique-pj";
import ProjetMiseEnPlaceTeletravail from "./projet-mise-en-place-teletravail";

// Mapping clé pièce jointe -> composant (clés en kebab-case)
export const pieceJointeContentComponents: Record<
  string,
  PieceJointeComponent
> = {
  "catalogue-demos-formation-rse": CatalogueDennosFormationRSE,
  "devis-lecco-construction": DevisConstructionAtelierProductionPJ,
  "facture-lecco-construction": FactureLeccoConstructionPJ,
  "formation-rse-monsieur-bart": FormationRSE,
  "licence-pro-grh-cnam": LicenceProCnam,
  "offre-abonnement-echos": OffreAbonnementEchosPJ,
  "projet-formation-demos": ProjetFormationDennosPJ,
  "projet-horaires-variables": ProjetHorairesVariables,
  "projet-informatique": ProjetInformatiquePJ,
  "projet-mise-en-place-teletravail": ProjetMiseEnPlaceTeletravail,
};

// Helper pour récupérer un composant de pièce jointe par sa clé
export function getPieceJointeContentComponent(
  cle: string,
): PieceJointeComponent | undefined {
  return pieceJointeContentComponents[cle];
}
